// Vendor Libs
import React from 'react';

// Components
import CreateUser from '../app/create-user';
import EditUser from '../app/edit-user';
import FlexDashboard from '../core/flex-dashboard';
import Permissions from '../core/permissions';
import UserLocks from '../search-data/user-locks';
import Users from '../search-data/users';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Users',
                        component: Users,
                    },
                    {
                        type: 'tab',
                        name: 'User Locks',
                        component: UserLocks,
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Create User',
                        component: CreateUser,
                        config: {
                            componentProps: {},
                        },
                    },
                    {
                        type: 'tab',
                        name: 'Edit User',
                        component: EditUser,
                    },
                ],
            },
        ],
    },
};

function DashboardUsers() {
    return (
        <Permissions adminOnly={true} autoRedirect={true}>
            <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="users" version="2" />
        </Permissions>
    );
}

export default DashboardUsers;
